<template>
  <v-app-bar app color="grey darken-4" dark height="72" hide-on-scroll extension-height="28">
    <!-- <data-tracker>{{ lastVisibleNav }}</data-tracker> -->
    <template v-if="marquee.isOn" #extension>
      <div class="marquee-wrap d-flex flex-row align-center mx-n4" style="width: 100vw">
        <marquee class="marquee text-caption" onmouseover="this.stop();" onmouseout="this.start();" v-html="marquee.html"> </marquee>
        <div class="btn-close" @click="marquee.isOn = false">
          <v-icon size="16">{{ icons['close'] }}</v-icon>
        </div>
      </div>
    </template>
    <div class="d-flex align-center">
      <v-img alt="UX" class="shrink mr-2" contain src="../../assets/uxlogo.svg" width="70" @click="changeRoute('/my-account/profile')" style="cursor:pointer" />
    </div>
    <nav class="nav-wrap d-none d-sm-inline-flex flex-wrap mr-6">
      <v-btn v-for="(nav, i) in navItems" :key="i" :class="nav.path === $route.path && 'active-nav'" class="grey--text text--lighten-1 font-weight-bold text-compressed" text>
        <span :ref="nav.label" @click="changeRoute(nav.path)" class="text-capitalize">{{ nav.label }}</span>
      </v-btn>
    </nav>
    <v-btn v-if="isNavWrapped && !isBalanceHovered" :style="chevronX" @click="show" absolute icon>
      <v-icon>{{ icons['chevronDown'] }}</v-icon>
    </v-btn>
    <v-menu v-model="moreMenu.show" :position-x="moreMenu.x" :position-y="moreMenu.y" absolute offset-y dark>
      <v-list>
        <div v-for="(item, index) in moreMenuItems" :key="index" class="d-flex flex-column">
          <v-list-item @click="changeRoute(item.path)">
            <v-list-item-title class="font-weight-bold text-compressed text-subtitle-2 grey--text text--lighten-1">
              <div>{{ item.label }}</div>
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="index < moreMenuItems.length - 1"></v-divider>
        </div>
      </v-list>
    </v-menu>
    <v-spacer></v-spacer>
    <v-hover>
      <div @mouseover="isBalanceHovered = true" @mouseout="isBalanceHovered = false" class="balance d-none d-sm-flex flex-row">
        <div class="balance-toggle flex-row">
          <v-btn icon>
            <v-icon>{{ icons['refresh'] }}</v-icon>
          </v-btn>
          <v-btn icon class="mr-2" @click="isBalanceShown = !isBalanceShown">
            <v-icon v-if="isBalanceShown">{{ icons['eyeHide'] }}</v-icon>
            <v-icon v-else>{{ icons['eyeShow'] }}</v-icon>
          </v-btn>
        </div>
        <div class="d-flex flex-column justify-center">
          <div class="text-caption grey--text text--lighten-1">{{ accountInfo.userName.value }}</div>
          <div class="font-weight-bold text-body-2 balance-value">{{ balanceInfo.currency.label }} {{ realBalance }}</div>
        </div>
      </div>
    </v-hover>
    <v-btn icon @click="toggleDrawer(true)" class="ml-2 mr-n1">
      <v-icon size="32">{{ icons['user'] }}</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  data() {
    return {
      marquee: {},
      navItems: [],
      chevronX: 0,
      moreMenu: {
        show: false,
        x: 0,
        y: 0,
      },
      isBalanceHovered: false,
      isBalanceShown: true,
    }
  },
  computed: {
    // local
    isNavWrapped() {
      return this.navItems.some((item) => item.isWrapped === true)
    },
    lastVisibleNav() {
      let ctrIndex = 0
      for (let item of this.navItems) {
        !item.isWrapped && ctrIndex++
      }
      return this.navItems[ctrIndex - 1].label
    },
    moreMenuItems() {
      return this.navItems.filter((item) => item.isWrapped)
    },
    realBalance() {
      return this.isBalanceShown ? this.balanceInfo.balance.amount : '-.-'
    },
    // getters
    accountInfo() {
      return this.$store.getters['Profile/accountInfo']
    },
    balanceInfo() {
      return this.$store.getters['Profile/balanceInfo']
    },
    storedMarquee() {
      return this.$store.getters['Common/marquee']
    },
  },
  methods: {
    show(e) {
      e.preventDefault()
      this.moreMenu.show = false
      this.moreMenu.x = e.clientX
      this.moreMenu.y = e.clientY
      this.$nextTick(() => {
        this.moreMenu.show = true
      })
    },
    setChevronPos() {
      const minY = this.$refs[this.navItems[1].label][0].getBoundingClientRect().y
      for (let navIndex in this.navItems) {
        const currentItem = this.navItems[navIndex]
        const currentY = this.$refs[currentItem.label][0].getBoundingClientRect().y
        if (currentY > minY) {
          // nav is wrapped
          currentItem.isWrapped === false && (currentItem.isWrapped = true)
        }
        if (currentY <= minY && currentItem.isWrapped) {
          // nav is unwrapped
          currentItem.isWrapped = false
        }
      }
      const chevronX = this.$refs[this.lastVisibleNav][0].getBoundingClientRect().x + this.$refs[this.lastVisibleNav][0].getBoundingClientRect().width
      this.chevronX = `left: ${chevronX + 16}px`
    },
    toggleDrawer(payload) {
      this.$store.dispatch('Drawer/toggleDrawer', payload)
    },
  },
  watch: {
    storedMarquee() {
      this.marquee = this.storedMarquee
    },
    fullNavLabels() {
      this.navItems = this.fullNavLabels
    },
  },
  created() {
    this.navItems = this.fullNavLabels // initiate nav from store
  },
  mounted() {
    this.$store.dispatch('Product/fetchProducts')
    this.setChevronPos()
    window.addEventListener('resize', this.setChevronPos)
    setTimeout(this.setChevronPos, 500)
  },
}
</script>

<style lang="sass" scoped>
.v-toolbar__content
  padding: 0

.nav-wrap
  max-height: 2.25rem
  overflow: hidden

.active-nav
  ::v-deep span
    color: white

.balance
  cursor: pointer
  &:hover
    .balance-toggle
      display: inline-flex
  .balance-toggle
    display: none
  .balance-value
    white-space: nowrap

.marquee-wrap
  .btn-close
    display: none
    margin-left: 0.5rem
    cursor: pointer
  &:hover
    // background-color: tomato
    .btn-close
      display: block
      // background-color: red
</style>
